import {
  INSERE_DADOS_OPERADOR,
  ATUALIZA_DADOS_OPERADOR,
  GET_DADOS_RELATORIO_OPERADOR_INDIVIDUAL,
} from './mutation-types'

export default {
  [INSERE_DADOS_OPERADOR]: (state, dadosOperador) => {
    const findElementInArray = state.dadosOperador.indexOf(element => element.operador === dadosOperador.operador)
    if (findElementInArray < 0) {
      state.dadosOperador.push(dadosOperador)
    }
  },

  [ATUALIZA_DADOS_OPERADOR]: (state, dadosOperador) => {
    state.dadosOperador.forEach((operador, key) => {
      if (operador.operador == dadosOperador.operador) {
        state.dadosOperador.splice(key, 1, dadosOperador)
      }
    })
  },

  [GET_DADOS_RELATORIO_OPERADOR_INDIVIDUAL]: (state, dadoRelatorioOperadorIndividual) => {
    state.dadoRelatorioOperadorIndividual = dadoRelatorioOperadorIndividual
  },
}
